import { Grid } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import { setOpenSections } from "components/app/App.slice";
import { isUndefined } from "lodash";
import React, { useState } from "react";
import { useParams } from "react-router";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import AccordionDetails from "./AccordionDetails";
import AccordionSummary from "./AccordionSummary";

interface Props {
  section: any;
  index: number;
  planType: string;
  planId: number;
}

export default function Index(props: Props) {
  const { secId }: any = useParams();
  const dispatch = useAppDispatch();
  const { cardList, sectionId } = useAppSelector((state) => state.app.selectedCards);
  const accordionState = useAppSelector((state: any) => state.app.openSectionsList);
  const [open, setOpen] = useState<boolean>(!!accordionState[props.section.id]);
  const [multiSelectMode, setMultiSelectMode] = useState(cardList.length && props.section.id === sectionId);

  const handleAccordianOpen = (e: React.SyntheticEvent) => {
    e.preventDefault();
    setOpen(!open);
    dispatch(setOpenSections({ [props.section.id]: !open }));
  };

  React.useEffect(() => {
    if (!isUndefined(secId) && !isUndefined(props.section.id) && String(secId) === String(props.section.id)) {
      setOpen(true);
      document.getElementById(props.section.id)?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  React.useEffect(() => {
    if (accordionState[props.section.id]) {
      setOpen(true);
    }
  }, [accordionState]);

  return (
    <Grid id={props.section.id} item xs={12} marginTop="16px">
      <Accordion
        sx={{
          padding: "16px",
          border: "none",
          boxShadow: "none",
          borderRadius: "12px",
          background: tokens.Background.General.Primary
        }}
        expanded={open}
        disableGutters
      >
        <AccordionSummary
          open={open}
          handleAccordianOpen={handleAccordianOpen}
          multiCardSelect={multiSelectMode}
          handleMultiSelectMode={() => {
            setMultiSelectMode(!multiSelectMode);
          }}
          {...props}
        />
        <AccordionDetails
          open={open}
          handleAccordianOpen={handleAccordianOpen}
          multiCardSelect={multiSelectMode}
          {...props}
        />
      </Accordion>
    </Grid>
  );
}
